import React, { useEffect, useState } from "react";
import "./header.scss";
import BrandLogo from "../../assets/images/logo/brandlogo.svg";
import ButtonPrimary from "../button/buttonPrimary/buttonPrimary";
import { DEEP_LINK_URL, LOGIN_BUTTON_MOBILE_TITLE, LOGIN_BUTTON_WEB_TITLE } from "../../constants/headerConstants";

const Header = () => {
  const [
    expandSearchInput,
    setExpandSearchInput,
  ] = useState(false);

  const [deviceWidth, setDeviceWidth] = useState(1024);

  useEffect(() => {
    if (typeof window !== "undefined") {
      setDeviceWidth(window.innerWidth);
    }
  }, []);

  const handleBtnClick = () => {
    window.open(DEEP_LINK_URL, "_blank", "noreferrer");
  }

  return (
    <>
      <header
        className={`header ${
          expandSearchInput ? "expand-search" : ""
        }`}
      >
        <div className="content-left">
          <a href="/" className="logo-wrap">
            <img
              src={BrandLogo}
              className="logo"
              alt="Share.Market logo"
            />
          </a>
          <a href="/blog" className="sub-text">
            <span>Blog</span>
          </a>
        </div>
        <div className="content-right">
          <div
            className={`search ${
              expandSearchInput ? "search-opened" : ""
            }`}
          >
            <span
              className="close-icon"
              onClick={() => {
                deviceWidth <= 600 &&
                  setExpandSearchInput(false);
              }}
            ></span>
            <form
              className="search-form"
              method="GET"
              action={"/blog/search"}
              autoComplete="off"
            >
              <input
                name="q"
                type="search"
                placeholder="Search topic and press Enter"
                className="search-input"
              />
              <span
                className="search-icon"
                onClick={() => {
                  deviceWidth <= 600 &&
                    setExpandSearchInput(true);
                }}
              >
                Search icon
              </span>
            </form>
          </div>
          <div className="button-wrap">
            {/* <ButtonPrimary customClass={ deviceWidth <= 768 ? 'trade-button-mobile' : 'login-btn' } deepLinkRedirect={handleBtnClick} title={ deviceWidth <= 768 ? LOGIN_BUTTON_MOBILE_TITLE : LOGIN_BUTTON_WEB_TITLE }/> */}
            <ButtonPrimary
              customClass={"login-btn"}
              deepLinkRedirect={handleBtnClick}
              title={LOGIN_BUTTON_WEB_TITLE}
            />
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
